import { initializeApp } from 'firebase/app';
import firebase from 'firebase/compat/app';
import 'firebase/analytics';
require ('firebase/auth');
require ('firebase/firestore');
require ('firebase/storage');

// Initialize Firebase
const firebaseConfig = 
{
  apiKey: "AIzaSyBbweTs_5H42C3rRUNsH0BEUeiK6xqpCdY",
  authDomain: "construvisor.firebaseapp.com",
  projectId: "construvisor",
  storageBucket: "construvisor.appspot.com",
  messagingSenderId: "559546797933",
  appId: "1:559546797933:web:6bf9a041882edfdcc09464",
  measurementId: "G-WTS1DB7L86"
};

initializeApp(firebaseConfig);

export default firebase;